<script>
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState(['activeUser']),
		show() {
			return !!(this.activeUser && this.activeUser.user);
		},
	},
	mounted() {
		this.releaseLock = () => this.$store.dispatch('clearActiveUserBeacon');
		window.addEventListener('pagehide', this.releaseLock);
		window.addEventListener('beforeunload', this.releaseLock);
	},
	beforeDestroy() {
		window.removeEventListener('pagehide', this.releaseLock);
		window.removeEventListener('beforeunload', this.releaseLock);
	},
};
</script>

<template>
	<div v-if="activeUser && activeUser.user">
		<b-modal
			id="activeuser"
			v-model="show"
			hide-footer
			hide-header
			hide-header-close
			no-close-on-backdrop
			no-close-on-esc
			centered
		>
			<div class="p-2">
				<h4>Oops! You’re not alone!</h4>
				<div>Someone else is currently working on this agreement.</div>
                <div>Ask your colleague to exit this client file in order to continue.</div>
				<hr />
				<b-button variant="primary" :to="{ name: 'home' }">Return to Client Files</b-button>
			</div>
		</b-modal>
	</div>
</template>

<style scoped>
</style>
